import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "UnidadAcademicaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "OrigenPage",
            ss: ss,
            ajax: {
                "url": ss.indexOrigen(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Origen', name: 'Origen', title: 'Origen' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            origenes: [],
            origen: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newOrigen() {
            this.origen = {};
            this.$refs['frm-origen'].show();
        },
        showOrigen(id) {
            this.isLoading=true;
            this.ss.showOrigen(id).then(
                (result) => {
                    let response = result.data;
                    this.origen = response.data;
                    this.$refs['view-origen'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editOrigen() {
            this.$refs['frm-origen'].show();
            this.$refs['view-origen'].hide();
        },
        cancelOrigen() {
            if (this.origen.id) {
                this.$refs['view-origen'].show();
            }
            this.$refs['frm-origen'].hide();
        },
        saveOrigen() {
            this.ss.storeOrigen(this.origen).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-origen'].hide();
                    this.$refs['datatable-origen'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteOrigen() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyOrigen(this.origen)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-origen'].hide();
                                this.$refs['datatable-origen'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Origen').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showOrigen(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
